import qs from 'qs';
import api from './api';
const itemServices = {

  addItem(payload: object) {
    const endpoint = '/items/create';
    return api.post(endpoint, payload);
  },
  editBookableItem(payload: object, itemId: number) {
    const queryParams = {
      item_id: itemId,
    };
    const queryString = qs.stringify(queryParams);
    const endpoint = `/items/edit/bookable-item?${queryString}`;
    return api.put(endpoint, payload);
  },
  hideItem( itemId: number, hide_item: boolean) {
    const queryParams = {
      id: itemId,
      hide_item: hide_item,
    };
    const queryString = qs.stringify(queryParams);
    const endpoint = `/item/hide?${queryString}`;
    console.log('Hiding item with ID:', endpoint);
    return api.put(endpoint);
  },
};
export default itemServices;